import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIconPlaceholder, ExternalLinkIcon } from './icons.js';
import { useClientServiceByTag } from '@hvsin/mod-client-runtime';
export function PwaLinkCard({ link }) {
    const apiClient = useClientServiceByTag('pwaLinksApiClient');
    const handleVisit = async (e) => {
        e.preventDefault();
        try {
            await apiClient.recordClick(link._id);
        }
        catch { /* ignore */ }
        window.open(link.url, '_blank', 'noopener,noreferrer');
    };
    return (_jsxs("a", { href: link.url, target: "_blank", rel: "noopener noreferrer", onClick: handleVisit, style: {
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            padding: '20px',
            borderRadius: 16,
            backgroundColor: '#fff',
            border: '1px solid #e5e7eb',
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }, onMouseEnter: (e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
            e.currentTarget.style.borderColor = '#d1d5db';
        }, onMouseLeave: (e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
            e.currentTarget.style.borderColor = '#e5e7eb';
        }, children: [link.icon ? (_jsx("img", { src: link.icon, alt: link.name, width: 56, height: 56, style: { borderRadius: 12, flexShrink: 0, objectFit: 'cover' }, onError: (e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling?.removeAttribute('style');
                } })) : null, _jsx("div", { style: { display: link.icon ? 'none' : 'flex' }, children: _jsx(AppIconPlaceholder, { size: 56, name: link.name }) }), _jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [_jsx("div", { style: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }, children: _jsx("h3", { style: {
                                margin: 0,
                                fontSize: 16,
                                fontWeight: 600,
                                color: '#111827',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }, children: link.name }) }), link.description ? (_jsx("p", { style: {
                            margin: '0 0 8px',
                            fontSize: 14,
                            color: '#6b7280',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            lineHeight: 1.5,
                        }, children: link.description })) : null, _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }, children: [link.category ? (_jsx("span", { style: {
                                    padding: '2px 8px',
                                    borderRadius: 999,
                                    backgroundColor: '#eff6ff',
                                    color: '#2563eb',
                                    fontSize: 12,
                                    fontWeight: 500,
                                }, children: link.category })) : null, link.tags?.slice(0, 3).map(tag => (_jsxs("span", { style: {
                                    padding: '2px 8px',
                                    borderRadius: 999,
                                    backgroundColor: '#f3f4f6',
                                    color: '#6b7280',
                                    fontSize: 12,
                                }, children: ["#", tag] }, tag)))] })] }), _jsxs("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    padding: '8px 14px',
                    borderRadius: 8,
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    fontSize: 13,
                    fontWeight: 500,
                    color: '#4b5563',
                    flexShrink: 0,
                }, children: ["\u8BBF\u95EE ", _jsx(ExternalLinkIcon, { size: 12, color: "#9ca3af" })] })] }));
}
//# sourceMappingURL=pwa-link-card.js.map